import { Controller } from "@hotwired/stimulus";
import { MOBILE_QUERY } from "../helpers/breakpoints";

// Mobile-only (reference design): the four stat tiles act as selectors for the
// big chart. Tapping a tile marks it active and notifies the chart component
// (window event — the chart lives in a sibling subtree). Desktop keeps
// non-interactive tiles (Max, 2026-08-06) — they are disabled there, so they are
// neither clickable nor reachable by keyboard.
export default class extends Controller {
  static targets = ["tile"];

  connect() {
    this.media = window.matchMedia(MOBILE_QUERY);
    this.onBreakpointChange = () => this.applyBreakpoint();
    this.media.addEventListener("change", this.onBreakpointChange);
    // Also resets the active tile of a Turbo-cached page back to the default.
    this.applyBreakpoint();
  }

  disconnect() {
    this.media?.removeEventListener("change", this.onBreakpointChange);
    this.media = undefined;
  }

  // The chart resets to its default metric on every breakpoint change, so the
  // tiles follow. The first tile is the default metric (view order).
  applyBreakpoint() {
    const mobile = this.media.matches;

    this.tileTargets.forEach((tile, index) => {
      tile.disabled = !mobile;
      this.markActive(tile, index === 0);
    });
  }

  select(event) {
    if (!this.media?.matches) return;

    const tile = event.currentTarget;
    this.tileTargets.forEach((other) => this.markActive(other, other === tile));
    this.dispatch("select", {
      detail: { key: tile.dataset.kpi },
      bubbles: true,
    });
  }

  markActive(tile, active) {
    tile.classList.toggle("is-active", active);
    tile.setAttribute("aria-pressed", String(active));
  }
}
